import { useMemo, useState, useEffect } from "react";
import { useApiUrl, useCustom, useTranslate } from "@refinedev/core";
import { NumberField } from "@refinedev/antd";
import { Line } from "@ant-design/charts";
import { LineConfig } from "@ant-design/plots/lib/components/line";
import dayjs, { Dayjs } from "dayjs";
import { Row, Col, Card, Typography, Form, Select,Table } from "antd";
import { useConfigProvider } from 'context';
import { IncreaseIcon, DecreaseIcon } from "components/icons";

import { ISalesChart } from "interfaces";

import {
    DailyRevenueWrapper,
    TitleAreNumber,
    TitleArea,
    FilterArea,
    TitleAreaAmount,
    RangePicker,
    SelectContainer,
    SelectPicker,
    SubTitleArea,
    SubTitleAreaAmount
} from "./styled";

import { LineChart } from "./lineChart"

interface Game {
    name: string;
    gameId: string;
}
interface Channel {
    name: string;
    channelId: string;
}

export const DailyRevenue: React.FC = () => {
    useEffect(() => {
        document.title = "ZUOMU";
      }, []);
    const t = useTranslate();
    const apiUrl = useApiUrl();
    const [multiGameTypeId, setMultiGameTypeId] = useState<string | null>(null);
    const [gameTypeId, setMGameType] = useState<string | null>(null);
    const [multiChannelId, setMultiChannelId] = useState<string | null>(null);
    const [channelId, setFrom] = useState<string | null>(null);
    const { mode } = useConfigProvider();
    const timeTransfer = (obj:any) => {
        if(obj){
            const year = obj.$y;
            const month = obj.$M;  // 注意，月份在Date对象里是从0开始的
            const date = obj.$D;
            const hours = obj.$H;
            const minutes = obj.$m;
            const seconds = obj.$s;
            const milliseconds = obj.$ms;
            const dateObject = new Date(year, month, date, hours, minutes, seconds, milliseconds);
            return dateObject.getTime();
        }
    }
    const { data, isLoading } = useCustom<any>({
        url: `${apiUrl}/sysinfo`,
        method: "get",
    });

    const gameType = [ 
        { label: t("diagrams.fields.gameType.chooseAll"), value: '' },
        ...(data?.data.data.gameIds.map((game: Game) => ({
            label: game.name,
            value: game.gameId,
        })) || []),
    ];

    const channelType = [
        { label: t("diagrams.fields.channelType.chooseAll"), value: '' },
        ...(data?.data.data.channelIds.map((channel: Channel) => ({
            label: channel.name,
            value: channel.channelId
        })) || []),
    ];

    console.log('---------gameType', gameType)
    console.log('---------channelType', channelType)

    console.log('-------mode', mode)

    const [multiDateRange, setMultiDateRange] = useState<[Dayjs, Dayjs]>([
        dayjs().subtract(7, "days").startOf("day"),
        dayjs().startOf("day"),
    ]);
    const [gameDateRange, setGameDateRange] = useState<[Dayjs, Dayjs]>([
        dayjs().subtract(7, "days").startOf("day"),
        dayjs().startOf("day"),
    ]);

    const [start1, end1] = multiDateRange;
    const [start2, end2] = gameDateRange;

    // const url = `${API_URL}/dailyRevenue`;
    const handleMultiGameType = (value: any) => {
        console.log(value)
        setMultiGameTypeId(value)
    }
    const handleGameType = (value: any) => {
        setMGameType(value)
    }
    const handleMultiChannelType = (value: any) => {
        console.log(value)
        setMultiChannelId(value)
    }
    const handleFrom = (value: any) => {
        setFrom(value)
    }

    const disabledDate = (date: Dayjs) => date > dayjs();


    const { data: getDataData, isLoading: getDataDataIsLoading } = useCustom<{
        data: any;
      
    }>({
        url: `${apiUrl}/roomtiming/getData`,
        method: "get",
        config: {
            query: {
                startTime: timeTransfer(start2),
                endTime: timeTransfer(end2),
                gameId: gameTypeId,
                channelId: channelId
            }
        },
    });


    console.log("getDataData",getDataData?.data.data.data)


    const listData = []
    let i = 0;
    for(const getDataDataItem in getDataData?.data.data.data){
        const {duration, startupTime} = getDataData?.data.data.data[getDataDataItem]
        listData.push({
            date: getDataDataItem,
            duration: Math.floor(duration / 60 / 1000),
            startupTime: startupTime,
            accumulated: 0,
            added: 0,
            active: 0,
        })
        i++;
    }

    return (
        <>
            {/* <Card
                bodyStyle={{
                    padding: 20,
                    paddingBottom: 100,
                }}
                style={{
                    background: mode === 'light' ? "url(images/map2.png)" : "url(images/daily-revenue.png)",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right",
                    backgroundSize: "cover",
                    marginBottom: "20px"
                }}
            >
                <DailyRevenueWrapper>
                    <TitleArea>
                        <TitleAreaAmount >
                            <Typography.Title level={3}>
                                {t("diagrams.multiPanel.title")}
                            </Typography.Title>
                        </TitleAreaAmount>
                    </TitleArea>
                    <FilterArea>
                        <SelectPicker
                            label={t("diagrams.fields.gameType.label")}
                            name="gamesId"
                            style={{
                                float: "right",
                                color: "#999999",
                                background: "rgba(255, 255, 255, 0.3)",
                            }}
                            mode={mode}
                        >
                            <SelectContainer
                                value={multiGameTypeId}
                                onChange={handleMultiGameType}
                                options={gameType}
                                placeholder={t("diagrams.fields.gameType.placeholder")}

                            />
                        </SelectPicker>
                        <SelectPicker
                            label={t("diagrams.fields.channelType.label")}
                            name="fromId"
                            style={{
                                float: "right",
                                color: "#fffff !important",
                                marginLeft: "20px",
                                background: "rgba(255, 255, 255, 0.3)",
                            }}
                            mode={mode}
                        >
                            <SelectContainer
                                onChange={handleMultiChannelType}
                                options={channelType}
                                placeholder={t("diagrams.fields.channelType.placeholder")}
                            />
                        </SelectPicker>
                        <RangePicker
                            size="small"
                            value={multiDateRange}

                            onChange={(values) => {
                                if (values && values[0] && values[1]) {
                                    setMultiDateRange([values[0], values[1]]);
                                }
                            }}
                            disabledDate={disabledDate}
                            style={{
                                float: "right",
                                marginLeft: "20px",
                                color: "#fffff !important",
                                background: "rgba(255, 255, 255, 0.3)",
                            }}
                            ranges={{
                                "This Week": [
                                    dayjs().startOf("week"),
                                    dayjs().endOf("week"),
                                ],
                                "Last Month": [
                                    dayjs().startOf("month").subtract(1, "month"),
                                    dayjs().endOf("month").subtract(1, "month"),
                                ],
                                "This Month": [
                                    dayjs().startOf("month"),
                                    dayjs().endOf("month"),
                                ],
                                "This Year": [
                                    dayjs().startOf("year"),
                                    dayjs().endOf("year"),
                                ],
                            }}
                            format="YYYY/MM/DD"
                        />
                    </FilterArea>
                    <LineChart type='Multi' start={{ start1 }} end={{ end1 }} gameTypeId={{ multiGameTypeId }} channelId={{ multiChannelId }} />
                </DailyRevenueWrapper>
            </Card> */}

            <Card
                bodyStyle={{
                    padding: 20,
                    paddingBottom: 360,
                }}
                style={{
                    background: mode === 'light' ? "url(images/map2.png)" : "url(images/daily-revenue.png)",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right",
                    backgroundSize: "cover",
                    marginBottom: "20px"
                }}
            >
                <DailyRevenueWrapper>
                    <TitleArea>
                        <TitleAreaAmount >
                            <Typography.Title level={3}>
                                {t("diagrams.gamePanel.title")}
                            </Typography.Title>
                        </TitleAreaAmount>
                    </TitleArea>
                    <FilterArea>
                        <SelectPicker
                            label={t("diagrams.fields.gameType.label")}
                            name="gamesId"
                            style={{
                                float: "right",
                                color: "#fffff !important",
                                background: "rgba(255, 255, 255, 0.3)",
                            }}
                            mode={mode}
                        >
                            <SelectContainer
                                onChange={handleGameType}
                                options={gameType}
                                placeholder={t("diagrams.fields.gameType.placeholder")}
                            />
                        </SelectPicker>
                        <SelectPicker
                            label={t("diagrams.fields.channelType.label")}
                            name="fromId"
                            style={{
                                float: "right",
                                color: "#fffff !important",
                                marginLeft: "20px",
                                background: "rgba(255, 255, 255, 0.3)",
                            }}
                            mode={mode}
                        >
                            <SelectContainer
                                onChange={handleFrom}
                                options={channelType}
                                placeholder={t("diagrams.fields.channelType.placeholder")}
                            />
                        </SelectPicker>
                        <RangePicker
                            size="small"
                            value={gameDateRange}
                            onChange={(values) => {
                                if (values && values[0] && values[1]) {
                                    setGameDateRange([values[0], values[1]]);
                                }
                            }}
                            disabledDate={disabledDate}
                            style={{
                                float: "right",
                                marginLeft: "20px",
                                color: "#fffff !important",
                                background: "rgba(255, 255, 255, 0.3)",
                            }}
                            ranges={{
                                "This Week": [
                                    dayjs().startOf("week"),
                                    dayjs().endOf("week"),
                                ],
                                "Last Month": [
                                    dayjs().startOf("month").subtract(1, "month"),
                                    dayjs().endOf("month").subtract(1, "month"),
                                ],
                                "This Month": [
                                    dayjs().startOf("month"),
                                    dayjs().endOf("month"),
                                ],
                                "This Year": [
                                    dayjs().startOf("year"),
                                    dayjs().endOf("year"),
                                ],
                            }}
                            format="YYYY/MM/DD"
                        />
                    </FilterArea>
                    <TitleArea>
                        {/* <SubTitleAreaAmount>
                            <Typography.Title
                                level={3}
                                style={{ marginTop: "20px", color: "#ffffff" }}
                            > */}
                        <div style={{ color: "#ffffff", fontSize: "16px" }}>
                            {t("diagrams.gamePanel.subtitle.dailyStartsDuration")}
                        </div>
                        {/* </Typography.Title>
                        </SubTitleAreaAmount> */}
                    </TitleArea>
                    <LineChart type='Duration' start={{ start2 }} end={{ end2 }} gameTypeId={{ gameTypeId }} channelId={{ channelId }} />
                    <TitleArea>
                        {/* <SubTitleAreaAmount>
                            <Typography.Title
                                level={3}
                                style={{ marginTop: "20px", color: "#ffffff" }}
                            > */}
                        <div style={{ color: "#ffffff", fontSize: "16px" }}>
                            {t("diagrams.gamePanel.subtitle.dailyStarts")}
                        </div>
                        {/* </Typography.Title>
                        </SubTitleAreaAmount> */}
                    </TitleArea>
                    <LineChart type='Times' start={{ start2 }} end={{ end2 }} gameTypeId={{ gameTypeId }} channelId={{ channelId }} />
                </DailyRevenueWrapper>
            </Card>


            <Card
                bodyStyle={{
                    padding: 20,
                    // paddingBottom: 100,
                }}
                style={{
                    background: mode === 'light' ? "url(images/map2.png)" : "url(images/daily-revenue.png)",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right",
                    backgroundSize: "cover",
                    marginBottom: "20px"
                }}
            >
                <TitleArea>
                        {/* <SubTitleAreaAmount>
                            <Typography.Title
                                level={3}
                                style={{ marginTop: "20px", color: "#ffffff" }}
                            > */}
                        <div style={{ color: "#ffffff", fontSize: "16px" }}>
                            {t("diagrams.gamePanel.subtitle.dailyStartsAll") + "：" + getDataData?.data.data.allStartupTime}
                            <br/>
                            {t("diagrams.gamePanel.subtitle.dailyStartsDurationAll") + "：" + Math.floor(getDataData?.data.data.allDuration / 60 / 1000)}
                        </div>
                        {/* </Typography.Title>
                        </SubTitleAreaAmount> */}
                    </TitleArea>
                <Table
                    columns={[
                        {
                            title: '日期',
                            width: 150,
                            dataIndex: 'date',
                            key: 'date',
                            fixed: 'left',
                        },
                        {
                            title: '启动时长（分）',
                            width: 150,
                            dataIndex: 'duration',
                            key: 'duration',
                            fixed: 'left',
                        },
                        {
                            title: '启动次数',
                            width: 150,
                            dataIndex: 'startupTime',
                            key: 'startupTime',
                            fixed: 'left',
                        },
                        {
                            title: '累计设备数量（暂无）',
                            width: 200,
                            dataIndex: 'accumulated',
                            key: 'accumulated',
                            fixed: 'left',
                        },
                        {
                            title: '新增设备数量（暂无）',
                            width: 200,
                            dataIndex: 'added',
                            key: 'added',
                            fixed: 'left',
                        },
                        {
                            title: '活跃设备数量（暂无）',
                            // width: 150,
                            dataIndex: 'active',
                            key: 'active',
                            fixed: 'left',
                        }
                    ]}
                    dataSource={listData}
                    pagination={false}
                    scroll={{
                    //   x: 1500,
                      y: 500,
                    }}
                ></Table>
            </Card>
        </>
    );
};
